const format_url = {
    development : {
        A02_MAIL : '1MSsku4oVNTBQKeFs0tFBp7cop2NZxC-_5OYVF2u8Yqo',
        A02_FAX : '183yKj8C42VuDMPgBcrPOPpNuNi7WsOG-aMod2S0YPU4',
        A02_SMS : '1wmTPlgRGmdIPoCeLIqAhvZ8cqKZoEqIXD8BHQELqfvI',
        C01_PDF : '1Hl_vkhY7kytYBM58OzS8V8A7Fl5HJwYWUwnhCDObyco',
        C02_PDF : '1AskPHEJyWdZ5kM-NJzNpk0amnDYICkFshs0Ph6Fk0KE',
        Y09_PDF : '1sUisCpftTSVm_q6MaVKnvmR2LJvLVnG7K7AtmGySg5A',
        Y12_PDF : '17vSQB9t1r9sKTxpO4UUt3b55eSdqrixWrRa5tW0Ecg0',// 東建コーポレーション　株式会社
        Y15_PDF : '1UCGxybSlx3CFO1oheCqAkKJRm8X3c5tueTwtpoFSLqo',
        Y16_PDF : '1GDcqt49oQYuU-7V-coZ-TJRwednoFAQR7vzOZChDEG4',
        C10_MAIL : '1Jq5PCLd32vRdJg2usfZVfVz_HgeUJBkRPdfYP3wveMI',
        C10_FAX : '1QuE8LU4uv2dU9xynCIh_aSW7AdfIUvW20aRlDtPSUlQ',
        C10_SMS : '16FpmBsbCEdScu3gYToACBeutYbeDinW4aei5Nxlu3kI',
        C11_MAIL : '1rIQQfoMttx4RF9ZU5l6lRrU2FU-2Vbm8y_BKf834mQg',
        C11_FAX : '1xl2hQwl1SWV48xR1XXHCV5R-fDeW4g-04Cer_SS27HE',
        C11_SMS : '1NSJKZ3Yf8KmVcwq_v5eSO1th681So-Y8h3NZbv3NAmo',
        C20_MAIL : '1QCUdgvvqIJValHZ-fcQ_zf6AQcPAh0A2rWw6JkmWcDI',
        C20_FAX : '17XtZENC34B1TMtBAIBxPHpFD_Dzpo0EVnaZmxurvOZc',
        C20_SMS : '1X9QBnsZ8wXbeOszrTVhQAdrjz2ypLLnNqq3WqzVNyXE',
        C21_MAIL : '1JQvYOTtSwWGCAeId2X6behqphEFysoZ5EEECQw5Sq1M',
        C21_FAX : '1dmhgknpvYHyLR_ShQ3pevLV1Fz-gpx3b_pEzT6l-vmA',
        C21_SMS : '1Flw7gLTRoWX1UYvr6VhCrH5Y4CNPxACvssOT189YJ70',
        D01_MAIL : '1v40RwSY9GYV0BODmXRMpnA-xhezHvHpc2NEUj4PEDEk',
        D01_FAX : '1b4-hTxEMJXSvJXy-5NVmkzEDLrlIRjoRLQ9p8EV9cwE',
        D01_SMS : '1bSbmHsK8NoyGHJfN3gy7Y15KwwZZSYEHqrjpIwGri9E',
        D02_PDF : '1arLEIK5znvSJ8-VTbCiDmjF86ev7NdOl3irmWtxb3l4',
        D02_MAIL : '141VPPCA69H1p4qwfbwLdftPwzG94cUOrsONaBgLU95s',
        D03_MAIL : '1dqHAARkVX9bQcVn1nKkGhGmNwopvLeS4N6K3shV5SpU',
        D03_FAX : '1UGjethTdjAhT-Pe_taX3PwNy1-ufj6fuP18EpbdLKMM',
        D03_SMS : '1kJriwmxRqGXJPCl-7niDM988b-jUC8Ng448NcINmiFE',
        F01_PDF : '1uANAnunxOLTkRc3Q0eiLAFRqi03aK7KOX6-OEzOEssY',
        F02_PDF : '1kog1_nooTaePVFPjLmSfX2X13Zn2toXBsqi2BLYR6to',
        Y13_PDF : '1LZ2iWek7fmCreDVCzO1tA05Zi1GhOa4zxVr-Am3gW-o',// 共ショウ
        F03_MAIL : '1Rr8uvAAGfuGJbVmWmzfxiNt4-H0PyFCCo6XuWkyQ_P0',
        F03_FAX : '1hDsgPTuduN1yt5BWttky1jC4fpCsprXPSLIfC76pDFc',
        F03_SMS : '1MbdkfufFVOVRpo16ae9eALWd2TFiZQGLsGBg_VVMGoc',
        F04_MAIL : '1xO31WFPcwECcYffD2UHGIS1A9-14fT0ssUYCcQ4gwus',
        F04_FAX : '1imEFVC9Co6d7Wu6HH8wQNTBOqFIs9NxZ64QXv_LG_Os',
        F04_SMS : '1vMq1KSwo3Pa8zizA63ln_zBXdbL4wZzzNZmWeRjdDc4',
        G03_PDF : '1ZDuT5mG-JcIa55o0oUBrya9M83CDkM7Ptca5-0y4KTY',
        G04_PDF : '1v13UQe7J4F9xGrmXXoutw_FK8s1bfDJO7cjtPD-sKR0',
        G05_PDF : '1N8qMJPCkpnxPEj9DhFIkgkEU3KHOLZHwWtvaafmnp8M',
        G06_PDF : '11b0Cy7Z1T2gMP0FI-XwM5m2OgRfPHmSoZulFBwiueOc',
        G13_PDF : '1WPzQwF8wxph_Snh7nH9cQ67y5K6DZmxyDmWACs659Es',
        G14_PDF : '1GRoEhvkVJz7CRY4OZr3SVh3MvqMNjj8koaenoHGPmlI',
        G15_PDF : '1qHVOHPqvKM4uM36aKEhx5cB5AR8T3Qkbcc8ASiRAOwg',
        H03_PDF : '1MJQ1a0l64-fZhbRSNdqhrAD1vcutWCHSaHUSKMowso4',
        H05_PDF : '1RjUnn-YQ1af7-x4F-bxB250uv5VLkm8ZN2CZlBAvaOM',
        H06_PDF : '1YC5t6pCRlCwi6UhpVy2S0EGw3AANIPcMZMqDv_Ybmm8',
        H07_PDF : '1g6ZWimn-Zk8ZyidBIDJC_YGpT8sB8z3L0KB2vDzqy0E',
        H08_PDF : '17Jv_n9VH3qfd2sCCMPuZNN8gFHh7zyGwQwf2TAjiLZM',
        Y10_PDF : '1w3yiPue_Wdc7FUWzXOLM98OkU6Sx7k0PWHRdGkn-88c',
        Y11_PDF : '1jqRzMNxgod7tWfTwYgxrFrPgqPnOeLMmyTHGV2jyCiA',
        Y02_PDF : '1p9-uxdyChdmMVcMyFjgle40LJ2BhK1oqQS1R1qmA4mU',
        Y03_PDF : '1MKQ7Ls2jo2K-M8yyymC4jfKNDnHHIL7lq3FGaECx4PU',
        Y04_PDF : '1yH8eFnfSOiXGjp-EGutKRcEnzwmOMyLgK7CEyAKrpl8',
        Y05_PDF : '1hKl6CqpTzmOt4zD7hU-af140NiY9RYSBHIHACuwPVBg',
        Y06_PDF : '1BBnjllIHMb9DOTiKVclVevltM8okCNyhLSu6OGcRebI',
        Y07_PDF : '1fbjh6Vs3HUAH1j6k9dsppqgJIC-ysAJbV8PeuHy-29I',
        Y08_PDF : '1rJB9aKozV0a0tp35xf0lb9eznvlfLMF9pEk_loctOPI',
        Y14_PDF : '1UyiuZPunjuD_1UgeNMAZ6LAdTQbhuM7bFnksElmkN9k',
        Y17_PDF : '1UK4_fZQaMVE_dZ-BeSR8VdL198_YIgBEY86L8U_1b_Q',
        C30_PDF : '1KAevCL7urCasNhsFROUcSy2UHCBL7-BfZ3rXTXAHqiA',
        C31_MAIL : '1QYzn746LU-pGIRW8ouhaeG-dae8mUS39YDePYoCxjM4',
        C31_SMS : '1rHgPOVF3nqyodridqhF8hp2-oLTNiLx6Kp0gWO79CMs',
        C32_MAIL : '17VwFhwvLRhmPgEZB4ciDq4AkV7HW9qaGR1C8e1PHhEM',
        C32_SMS : '19J5_RIPOJrOfzAqP1pSinyeu96WTcgABhqzlLlnqtPs',
        K01_FAX : '1RCBHq2pF-4vI0NuEMxGokoRg4y8k2OlkFbQik4weNvk',
        Z01_AUTO:'1NefJVVl7aMn5DPojgbsguHyTT9s6QcnTqxCvFu_2nM4', // イトーピアホーム　株式会社
        Z02_AUTO:'1_uNP4O-Dv16m1LhSjG2BKiBLNzZUL54yK3EgJSAPgYw', // 東建コーポレーション　株式会社
        C40_MAIL : '1zpbHm9DtLVVP3iiu2Yv5nNEo-VO428z2ou50TWFq-g8',
        C40_SMS : '1KQugJvX71e7jmmOpkftvr-PRIfyL3NGdlxE_TYdl7VU',
        C50_MAIL : '1HQXIJEEqCJUsCrYrFLBRkJJoBntgeXUZQiQWohzqqpQ',
        D10_MAIL : '1XrbrImrY1AixaSZ98EhdKpG1IoX_mdvu4RmCYlEkaPs',
        F10_MAIL : '1SNkS3bYnJ4fLARtYyGI5KZqDcmw8w44v6OJWs703F0g',
        F10_SMS : '1sh3NPXA1YdBwnrdThcCK6zKh5G_jVondEYiJhUQh4GY',
        G10_MAIL : '1aT3v-vlB5ZGD984xvpxuJ620I0fo5smi07h76_9GmrU',
        G20_MAIL : '1d-f0vpRJg21Uqdzv9sfRfAADEtVeF2ZhVBOuHMMLboQ',
        G20_SMS : '17dYL_qsejueMXCTmvCeWZmZO5THFhZP3vBc5uvQ5KN0',
        Z03_AUTO : '1QJzHT44oEgMS1Q3oSmdMbpwUeYFg-b7Y8RVGLDybfdA', // 一覧帳票（オープンハウス・ディベロップメント）
    },
    staging : {
        A02_MAIL : '1MSsku4oVNTBQKeFs0tFBp7cop2NZxC-_5OYVF2u8Yqo',
        A02_FAX : '183yKj8C42VuDMPgBcrPOPpNuNi7WsOG-aMod2S0YPU4',
        A02_SMS : '1wmTPlgRGmdIPoCeLIqAhvZ8cqKZoEqIXD8BHQELqfvI',
        C01_PDF : '1Hl_vkhY7kytYBM58OzS8V8A7Fl5HJwYWUwnhCDObyco',
        C02_PDF : '1AskPHEJyWdZ5kM-NJzNpk0amnDYICkFshs0Ph6Fk0KE',
        Y09_PDF : '1sUisCpftTSVm_q6MaVKnvmR2LJvLVnG7K7AtmGySg5A',
        Y12_PDF : '17vSQB9t1r9sKTxpO4UUt3b55eSdqrixWrRa5tW0Ecg0',// 東建コーポレーション　株式会社
        Y15_PDF : '1UCGxybSlx3CFO1oheCqAkKJRm8X3c5tueTwtpoFSLqo',
        Y16_PDF : '1GDcqt49oQYuU-7V-coZ-TJRwednoFAQR7vzOZChDEG4',
        C10_MAIL : '1Jq5PCLd32vRdJg2usfZVfVz_HgeUJBkRPdfYP3wveMI',
        C10_FAX : '1QuE8LU4uv2dU9xynCIh_aSW7AdfIUvW20aRlDtPSUlQ',
        C10_SMS : '16FpmBsbCEdScu3gYToACBeutYbeDinW4aei5Nxlu3kI',
        C11_MAIL : '1rIQQfoMttx4RF9ZU5l6lRrU2FU-2Vbm8y_BKf834mQg',
        C11_FAX : '1xl2hQwl1SWV48xR1XXHCV5R-fDeW4g-04Cer_SS27HE',
        C11_SMS : '1NSJKZ3Yf8KmVcwq_v5eSO1th681So-Y8h3NZbv3NAmo',
        C20_MAIL : '1QCUdgvvqIJValHZ-fcQ_zf6AQcPAh0A2rWw6JkmWcDI',
        C20_FAX : '17XtZENC34B1TMtBAIBxPHpFD_Dzpo0EVnaZmxurvOZc',
        C20_SMS : '1X9QBnsZ8wXbeOszrTVhQAdrjz2ypLLnNqq3WqzVNyXE',
        C21_MAIL : '1JQvYOTtSwWGCAeId2X6behqphEFysoZ5EEECQw5Sq1M',
        C21_FAX : '1dmhgknpvYHyLR_ShQ3pevLV1Fz-gpx3b_pEzT6l-vmA',
        C21_SMS : '1Flw7gLTRoWX1UYvr6VhCrH5Y4CNPxACvssOT189YJ70',
        D01_MAIL : '1v40RwSY9GYV0BODmXRMpnA-xhezHvHpc2NEUj4PEDEk',
        D01_FAX : '1b4-hTxEMJXSvJXy-5NVmkzEDLrlIRjoRLQ9p8EV9cwE',
        D01_SMS : '1bSbmHsK8NoyGHJfN3gy7Y15KwwZZSYEHqrjpIwGri9E',
        D02_PDF : '1arLEIK5znvSJ8-VTbCiDmjF86ev7NdOl3irmWtxb3l4',
        D02_MAIL : '141VPPCA69H1p4qwfbwLdftPwzG94cUOrsONaBgLU95s',
        D03_MAIL : '1dqHAARkVX9bQcVn1nKkGhGmNwopvLeS4N6K3shV5SpU',
        D03_FAX : '1UGjethTdjAhT-Pe_taX3PwNy1-ufj6fuP18EpbdLKMM',
        D03_SMS : '1kJriwmxRqGXJPCl-7niDM988b-jUC8Ng448NcINmiFE',
        F01_PDF : '1uANAnunxOLTkRc3Q0eiLAFRqi03aK7KOX6-OEzOEssY',
        F02_PDF : '1kog1_nooTaePVFPjLmSfX2X13Zn2toXBsqi2BLYR6to',
        Y13_PDF : '1LZ2iWek7fmCreDVCzO1tA05Zi1GhOa4zxVr-Am3gW-o',// 共ショウ
        F03_MAIL : '1Rr8uvAAGfuGJbVmWmzfxiNt4-H0PyFCCo6XuWkyQ_P0',
        F03_FAX : '1hDsgPTuduN1yt5BWttky1jC4fpCsprXPSLIfC76pDFc',
        F03_SMS : '1MbdkfufFVOVRpo16ae9eALWd2TFiZQGLsGBg_VVMGoc',
        F04_MAIL : '1xO31WFPcwECcYffD2UHGIS1A9-14fT0ssUYCcQ4gwus',
        F04_FAX : '1imEFVC9Co6d7Wu6HH8wQNTBOqFIs9NxZ64QXv_LG_Os',
        F04_SMS : '1vMq1KSwo3Pa8zizA63ln_zBXdbL4wZzzNZmWeRjdDc4',
        G03_PDF : '1ZDuT5mG-JcIa55o0oUBrya9M83CDkM7Ptca5-0y4KTY',
        G04_PDF : '1v13UQe7J4F9xGrmXXoutw_FK8s1bfDJO7cjtPD-sKR0',
        G05_PDF : '1N8qMJPCkpnxPEj9DhFIkgkEU3KHOLZHwWtvaafmnp8M',
        G06_PDF : '11b0Cy7Z1T2gMP0FI-XwM5m2OgRfPHmSoZulFBwiueOc',
        G13_PDF : '1WPzQwF8wxph_Snh7nH9cQ67y5K6DZmxyDmWACs659Es',
        G14_PDF : '1GRoEhvkVJz7CRY4OZr3SVh3MvqMNjj8koaenoHGPmlI',
        G15_PDF : '1qHVOHPqvKM4uM36aKEhx5cB5AR8T3Qkbcc8ASiRAOwg',
        H03_PDF : '1MJQ1a0l64-fZhbRSNdqhrAD1vcutWCHSaHUSKMowso4',
        H05_PDF : '1RjUnn-YQ1af7-x4F-bxB250uv5VLkm8ZN2CZlBAvaOM',
        H06_PDF : '1YC5t6pCRlCwi6UhpVy2S0EGw3AANIPcMZMqDv_Ybmm8',
        H07_PDF : '1g6ZWimn-Zk8ZyidBIDJC_YGpT8sB8z3L0KB2vDzqy0E',
        H08_PDF : '17Jv_n9VH3qfd2sCCMPuZNN8gFHh7zyGwQwf2TAjiLZM',
        Y10_PDF : '1w3yiPue_Wdc7FUWzXOLM98OkU6Sx7k0PWHRdGkn-88c',
        Y11_PDF : '1jqRzMNxgod7tWfTwYgxrFrPgqPnOeLMmyTHGV2jyCiA',
        Y02_PDF : '1p9-uxdyChdmMVcMyFjgle40LJ2BhK1oqQS1R1qmA4mU',
        Y03_PDF : '1MKQ7Ls2jo2K-M8yyymC4jfKNDnHHIL7lq3FGaECx4PU',
        Y04_PDF : '1yH8eFnfSOiXGjp-EGutKRcEnzwmOMyLgK7CEyAKrpl8',
        Y05_PDF : '1hKl6CqpTzmOt4zD7hU-af140NiY9RYSBHIHACuwPVBg',
        Y06_PDF : '1BBnjllIHMb9DOTiKVclVevltM8okCNyhLSu6OGcRebI',
        Y07_PDF : '1fbjh6Vs3HUAH1j6k9dsppqgJIC-ysAJbV8PeuHy-29I',
        Y08_PDF : '1rJB9aKozV0a0tp35xf0lb9eznvlfLMF9pEk_loctOPI',
        Y14_PDF : '1UyiuZPunjuD_1UgeNMAZ6LAdTQbhuM7bFnksElmkN9k',
        Y17_PDF : '1UK4_fZQaMVE_dZ-BeSR8VdL198_YIgBEY86L8U_1b_Q',
        C30_PDF : '1KAevCL7urCasNhsFROUcSy2UHCBL7-BfZ3rXTXAHqiA',
        C31_MAIL : '1QYzn746LU-pGIRW8ouhaeG-dae8mUS39YDePYoCxjM4',
        C31_SMS : '1rHgPOVF3nqyodridqhF8hp2-oLTNiLx6Kp0gWO79CMs',
        C32_MAIL : '17VwFhwvLRhmPgEZB4ciDq4AkV7HW9qaGR1C8e1PHhEM',
        C32_SMS : '19J5_RIPOJrOfzAqP1pSinyeu96WTcgABhqzlLlnqtPs',
        K01_FAX : '1RCBHq2pF-4vI0NuEMxGokoRg4y8k2OlkFbQik4weNvk',
        Z01_AUTO:'1NefJVVl7aMn5DPojgbsguHyTT9s6QcnTqxCvFu_2nM4', // イトーピアホーム　株式会社
        Z02_AUTO:'1_uNP4O-Dv16m1LhSjG2BKiBLNzZUL54yK3EgJSAPgYw', // 東建コーポレーション　株式会社
        C40_MAIL : '1zpbHm9DtLVVP3iiu2Yv5nNEo-VO428z2ou50TWFq-g8',
        C40_SMS : '1KQugJvX71e7jmmOpkftvr-PRIfyL3NGdlxE_TYdl7VU',
        C50_MAIL : '1HQXIJEEqCJUsCrYrFLBRkJJoBntgeXUZQiQWohzqqpQ',
        D10_MAIL : '1XrbrImrY1AixaSZ98EhdKpG1IoX_mdvu4RmCYlEkaPs',
        F10_MAIL : '1SNkS3bYnJ4fLARtYyGI5KZqDcmw8w44v6OJWs703F0g',
        F10_SMS : '1sh3NPXA1YdBwnrdThcCK6zKh5G_jVondEYiJhUQh4GY',
        G10_MAIL : '1aT3v-vlB5ZGD984xvpxuJ620I0fo5smi07h76_9GmrU',
        G20_MAIL : '1d-f0vpRJg21Uqdzv9sfRfAADEtVeF2ZhVBOuHMMLboQ',
        G20_SMS : '17dYL_qsejueMXCTmvCeWZmZO5THFhZP3vBc5uvQ5KN0',
        Z03_AUTO : '1QJzHT44oEgMS1Q3oSmdMbpwUeYFg-b7Y8RVGLDybfdA', // 一覧帳票（オープンハウス・ディベロップメント）
    },
    production : {
        A02_MAIL : '1YfO4Gu4NiFWuha4kJ4bTFlHltJ8NgRJowRKWP3t5CaM',
        A02_FAX : '1UcravRyKq8L9TSAPx0hMzsiOVeAWR_kMx6KZs8OAFh0',
        A02_SMS : '1RLmV-Vz3nWC_vVn_yMQoWNmzZ2Sn_jvpXSv24xKniS8',
        C01_PDF : '1bqj10waKv_2engpc_OcQe-KpSO4ew0a_JQA3wdqo7jk',
        C02_PDF : '18h4VU5jxX9FiqerhJFBu18DtiA-f3u505u0ksW8V_sU',
        Y09_PDF : '1ahtEelclC7vR28FO1qug6eklpg-giid4N2GRJ_VDU88',
        Y12_PDF : '1y7BzwDEwz7To7GDGUoIPxbuio_VXB_qvGau9CK5ANbg',
        Y15_PDF : '1mBzkSainqXkzjQTnd3-oTvvat7hLkeVZJ1n1TGMlJIg',
        Y16_PDF : '1tH5TzUiDvqDNox_X2tWFeluPmA7yMFPCA34xTpozEs4',
        C10_MAIL : '19c60MPINAWrRSAaAY462Al7nlXRP-yBd1dX_w1V1hTo',
        C10_FAX : '1GBief98aBxRoHSHvYW_fhfrSXpWw7xVgxSaRHNmAWuQ',
        C10_SMS : '18zh8NKLBftqRU7p5fe7TSIaK7V8Dsub4WqmA_cFP-WE',
        C11_MAIL : '1Fpz53YovaNMT3KKsig0eyO0-zWo8Hdd_-npMmGTltfs',
        C11_FAX : '18dwSbI_hyjei4muYD9A6RLxBeZdha7qSUuPt32cbzkQ',
        C11_SMS : '1O-0ncS-K5hNHRrxjY0_S6j4-dYCOV4IhHqEmEwstXfw',
        C20_MAIL : '1O-y21dIvvSjUfLcQ8xSojS0HXgGpdpiTNrza9PWtZyQ',
        C20_FAX : '10oJpScq0MHaDfLNNnMRX80-sXoWTBWrdzCF7U7Zg6N8',
        C20_SMS : '1AmLx8QUUelyW0NX9fHzWD3HUe3tBbUMiUwdtS_70cPA',
        C21_MAIL : '1h6ncC9OTsfUY5DmTchaZEOuxvnoEKfDFjToxFTfJ_G4',
        C21_FAX : '14JtazGTs-7tKUCZ5faFoKTSfMjEDeoi1_br6rNa1fh8',
        C21_SMS : '1m2mGQdvV784WdZexCl0sFy9JPmzjc4M1Pa54e3FJd98',
        D01_MAIL : '1DaidTAVrCDNk5ZCdGRgLMtQvBD_AD4KGioZYwOfNTQY',
        D01_FAX : '1uL0oS2D-C_siX1Dp_PdvrhyXlFFCMbLRf0aAthZpG9w',
        D01_SMS : '1ei97OLON-xIZ8mqCX1mT8g_BKtKwW2FEINUf7rwfe8M',
        D02_PDF : '1O9k4GO6AiJNjVjmXfm7BO-K_k87yOkTpLZA4XozSDyg',
        D02_MAIL : '1TMp75Ir1ijQ0Yiry3KCcZBfbegMjjPkE4uiJd4OLYto',
        D03_MAIL : '1Br_cGl2CGzinerRCaslHMqhueg3EspW_wbRPZBcQRg0',
        D03_FAX : '1ha0CXIJOG1LSJR5jzyBuN7kBj5RKGGSDFamWM2ND2aw',
        D03_SMS : '1wJIAfsjve0i6a3YZrrnw6GfLiYn2Gn8X61FrUNdMYwM',
        F01_PDF : '1xlYAFJfRNfWqWN5E4vvWxSeVxrSGtF9vAIu1h9qv0zg',
        F02_PDF : '1FguKnUlwSuVeo_--xtz8K_Gtv4Y79HGwLCZ3_ORQhYs',
        Y13_PDF : '1B_O7sc9aReZ9V-oUtJMUTVoUs1O56dD3jGVhqdyrRNQ',
        F03_MAIL : '1gOi6R0gy9ogrbK7MeqA0ihq7murxsKsji4xgbeWHcxI',
        F03_FAX : '1a15AI-dAkYVYcnV4nV_vd2_Kz7iygWAkRROijmj7Dak',
        F03_SMS : '1I5bvEZc3iCtvXKMN2MlxuNDnnzFyg6S68byOhzcnGVM',
        G03_PDF : '1VJIIVFBntONDbQFKYyxzR5hQvo01Q4V1FfFTdgmEHzA',
        G04_PDF : '10oYIeTHTaPXDLvPT9_r4M87Nsiz5oL_bRa9kApr4vS8',
        G05_PDF : '1cmm3gWO--LlNS6EL5EH74xIX2Bg7b3z3mJ4NkQoCPW4',
        G06_PDF : '1692iGzAJNDbMNKhoIdYMD48ugPH8I3MhMRbcXhSaFv8',
        G13_PDF : '1-G5Oth7ZxInJdcXnytw4S3EvDhBHkmHpNl-UFNeNSPw',
        G14_PDF : '1sfIjA9EPNIKDygMk8tdfF-aNXAd65NNVNB-7tng_p6k',
        G15_PDF : '1YE0e5WtQtR9FMIcw3neYRCYAmfN6PTw5lp9OaqC_990',
        H03_PDF : '12BGCwmDhr_SZ5tpfClPQFu8H0fKsv2ZR6cGoh13mMbA',
        H05_PDF : '1g4sht1UyM-RcBmKWNI5UOeh0O2roadX75kQwyDaVvO0',
        H06_PDF : '1it5LxHfzDHe0cn_w59ky2egHBrKWZdoHKuyP5hEg6-U',
        H07_PDF : '1Uf2s4ruG6elKO7oh-bUbI4D-H5sja6sevybz7w4xHOg',
        Y10_PDF : '1Wa-mUWna1g7JUov6P7MkIANHHONF5AXXfymwJFtkR24',
        Y11_PDF : '1yO7P8mgbqfKFstMEgxr5qSNIJKGRM_L85OT-9GwKwa0',
        H08_PDF : '1PTRsTnoziZpANA03dwO4r9e348EBjken5z4XWz-zGbU',
        Y02_PDF : '1Q3UbotJRMfgydvDgI0XqP0gKHhhjUhvWZPhsg5FIb7g',
        Y03_PDF : '1wisDHIR0_sM1_J5iTRSPcP5idqRgD7pvt06Du9NHfVg',
        Y04_PDF : '1f-qJF-kc-F9jUh7JeZ-BL8K45k1F1wqT8ZmQ6ylyFA8',
        Y05_PDF : '1mwjrsNM8277ofiBVDfZdCdALeVeH-73BhCUBB0ZYsVI',
        Y06_PDF : '1Yue_ZougqCFKg430X7ke8iOgZcOsZFkZHhDrckPCi7I',
        Y07_PDF : '18toQG8CKRxAg21YtbN4GkxMvU-h3cc2Luu4RC2og2ck',
        Y08_PDF : '1xCIi5XPGaojUrEQKym9qnp1Cbm_tuzGlbT41fTSrjs0',
        Y14_PDF : '1AqamIt8WvTA4bZ7HCvBT2Gz7QTLSyLLg9vP3qWfsmCY',
        Y17_PDF : '1wBFF4ova4UFtcOaMqj98dFVUjVF_LWoVLL5f7MTknyI',
        C30_PDF : '15ihQ9Tr35_bqVS4geUn2NnyWqN9THj0wVg2DEE7g0xw',
        C31_MAIL : '1PmfVPjgZ_GWKFTR1g9a84BetqPj8c-xLWO1VhTBQkjs',
        C31_SMS : '1tDP2DwfIPU0ShUg32lNyfzw9XV54zUaOwCyhLRyuJp4',
        C32_MAIL : '1rbplHC5ByYPqifef-5Le1uGphHYzqwbFPzHVeLBUHpQ',
        C32_SMS : '1oQeNjklUsGiJYznK1vQfi6jenwSJtuqxw-uoqadNUWM',
        K01_FAX : '1Jsxw1Z__XOqhgpsn6LmLvyfOcDMQUO4CI70kD00Cnl0',
        Z01_AUTO:'1CPdt_houJlNP0t1UkCqAoSvEgfGT8jqbUoD0BlT3S5o', // イトーピアホーム　株式会社
        Z02_AUTO:'1Zz8ir2plywGYKm9ogJyrmHbOF1i4FKzUR4HqopJG97I', // 東建コーポレーション　株式会社
        G10_MAIL : '1BEWtsrwIRihtGoNQarGpGXeK2mf7lM4UubRjclh26js',
        C40_MAIL : '11GLhnr9fIOqMhhSp0a6iv-OheNOk3GbGRjGHwhRtFFg',
        C40_SMS : '1Sqy08GkPQytb6AUCtrYEdPsKh_eLoQAwNsVxMGEwc3k',
        C50_MAIL : '1USia05Q_x_ui7eUhOIWhOX6sIrSUFLwMceTZyai6jkk',
        D10_MAIL : '1-D9Fg8fH93aFFGug05h_jwxYbfIOEKdvU0J8XZUti8w',// 仕入NG通知
        F10_MAIL : '1oSWzh3mRinBoLpSF2BioHnwACEtfWXU_t1cHLyV_sGM',
        F10_SMS : '1SNcweznOtJ9dF6Z0qOlnADQFYCwHhozLuE1J3y7Ppos',
        G20_MAIL : '1SEVfSkL8qmuhXSPyywxGcdwbf4uvr5RC7IPknaVT_No',
        G20_SMS : '1KlSgiDocWA-9YHYAlokdTCcD0Fl1SMDRFbVV1j7f9eA',
        Z03_AUTO : '1kIa9AAaCmZCu8r1eQiUeBNWTtkpdWqJ4-ohNLoJ4rAU' // 一覧帳票（オープンハウス・ディベロップメント）
    }
}
// env values : production, staging, development
// console.log(process.env.REACT_APP_MODE)
export default format_url[process.env.REACT_APP_MODE]
